type Props = { sanitizedContent: string }

export const MDtoHTML = ({ sanitizedContent }: Props) => {
	return <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
}
